import { Navigate, Outlet, RouteObject, useLocation } from "react-router-dom";

import { PendingUserBanner } from "@/common/components/pending-user-banner/pending-user-banner";
import { RequireErpCompany } from "@/common/components/require-erp-company/require-erp-company";

const getAbsolutePath = (path: string) => `/${path}`;

const wrapWithCompanyGuards = (routes: RouteObject[]) => [
  {
    children: routes,
    element: (
      <PendingUserBanner>
        <RequireErpCompany>
          <Outlet />
        </RequireErpCompany>
      </PendingUserBanner>
    ),
  },
];

const NavigateToInitialPage = ({ page }: { page: string }) => {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return <Navigate replace to={getAbsolutePath(page)} />;
  }

  return null;
};

export { getAbsolutePath, NavigateToInitialPage, wrapWithCompanyGuards };
